import BidGroupVendorSpecQuote from "../BidGroupVendorSpecQuote";

describe("BidGroupVendorSpecQuote Model", () => {
  test("belongsTo relations", () => {
    expect(
      BidGroupVendorSpecQuote.belongsTo.map(relation => relation.name)
    ).toMatchSnapshot();
  });

  test("hasMany relations", () => {
    expect(
      BidGroupVendorSpecQuote.hasMany.map(relation => relation.name)
    ).toMatchSnapshot();
  });
});
